import { UiButton } from "./UiButton";
import { ButtonOptions } from "./ButtonOptions";
import { IDestroyOptions } from "@pixi/display";
import { gsap } from "gsap";
import { AudioManager } from "../../../../audio/AudioManager";

type Timeline = gsap.core.Timeline;
export class ScaleUpButton extends UiButton {
    protected hoverAnimation: Timeline;

    public constructor(
        public readonly options: ButtonOptions,
        audioManager: AudioManager
    ) {
        super(options.defaultTexture, audioManager);
        this.onHover.add(this.handleHover, this);
        this.onOut.add(this.handleOut, this);
        this.onUpOut.add(this.handleOut, this);
        this.on("pointerleave", this.handlePointerLeave, this);
        this.hoverAnimation = new gsap.core.Timeline({ paused: true });
    }

    protected async handleHover(): Promise<void> {
        this.resetAnimation();
        this.initHoverAnimation();
        await this.hoverAnimation.play();
    }

    protected override handleUp(): void {
        super.handleUp();
        this.resetAnimation();
    }

    protected handleOut(): void {
        this.resetAnimation();
    }

    protected handlePointerLeave(): void {
        this.resetAnimation();
    }

    protected initHoverAnimation(): void {
        const startPosition = this.position.clone();
        const width = this.width;
        const height = this.height;
        const scaleFrom = 1;
        const scaleTo = 1.13;
        this.hoverAnimation
            .fromTo(this.scale,
                {
                    x: scaleFrom,
                    y: scaleFrom
                },
                {
                    x: scaleTo,
                    y: scaleTo,
                    ease: "none",
                    duration: 0.15
                })
            .fromTo(this.position,
                {
                    x: startPosition.x,
                    y: startPosition.y
                },
                {
                    x: startPosition.x + (width - width * scaleTo) * 0.5,
                    y: startPosition.y + (height - height * scaleTo) * 0.5,
                    ease: "none",
                    duration: 0.15
                }, "<")
            .yoyo(true)
            .repeat(-1);
    }

    protected resetAnimation(): void {
        this.hoverAnimation?.pause(0);
        this.hoverAnimation?.clear();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.off("pointerleave", this.handlePointerLeave, this);
        this.hoverAnimation?.kill();
        this.onUpOut.remove(this.handleOut, this);
        this.onOut.remove(this.handleOut, this);
        this.onUpOut.remove(this.handleOut, this);
        this.onHover.remove(this.handleHover, this);
        super.destroy(options);
    }
}